import Footer from "../../components/Footer";
import Header from "../../components/Header";
import PrecisionMetering from "../../components/Service/Subservice/metering";
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function PrecisionMeteringPage() {
    return (
        <>
            <Header/>
            {/* Professional title focused on accuracy and analytics */}
            <SubServiceBanner title={"Precision Metering & Energy Analytics"}/>
            
            <PrecisionMetering/>
            
            <Footer/>
        </>
    )
}